import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ChatUserPresenter from 'presenters/ChatUserPresenter';
import MessagePresenter from 'presenters/MessagePresenter';
import ScrollToBottom from 'react-scroll-to-bottom';

import Messages from './components/Messages';
import NewMessageField from './components/NewMessageField';

import useStyles from './useStyles';

const Chat = props => {
  const classes = useStyles();

  const {
    isLoanOfficer,
    chatCurrentUser,
    chatParticipant,
    onMessageSend,
    messages,
    onMessagesRead,
    chatUid,
    isMessagesLoading,
  } = props;

  useEffect(() => {
    onMessagesRead(chatUid);
  }, [messages]);

  const handleSendMessage = newMessage => {
    const message = { ...newMessage, senderId: chatCurrentUser.id };
    onMessageSend(chatParticipant.id, chatUid, message);
  };

  return (
    <div className={classes.container}>
      <div className={classes.messages}>
        <ScrollToBottom className={classes.messagesContainer} scrollViewClassName={classes.scrollView}>
          <Messages
            currentUser={chatCurrentUser}
            participant={chatParticipant}
            messages={messages}
            isLoading={isMessagesLoading}
            chatUid={chatUid}
          />
        </ScrollToBottom>
      </div>
      <NewMessageField onMessageSend={handleSendMessage} isLoanOfficer={isLoanOfficer} />
    </div>
  );
};

Chat.propTypes = {
  chatParticipant: ChatUserPresenter.shape().isRequired,
  chatUid: PropTypes.string.isRequired,
  isMessagesLoading: PropTypes.bool.isRequired,
  chatCurrentUser: ChatUserPresenter.shape().isRequired,
  onMessagesRead: PropTypes.func.isRequired,
  onMessageSend: PropTypes.func.isRequired,
  messages: PropTypes.arrayOf(MessagePresenter.shape()),
};

Chat.defaultProps = {
  messages: [],
};

export default Chat;



// WEBPACK FOOTER //
// ./src/sharedComponents/Chat/Chat.js